import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCapture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCapture"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H9V4.5H4.5V9H3V3ZM15 3H21V9H19.5V4.5H15V3ZM4.5 15V19.5H9V21H3V15H4.5ZM21 15V21H15V19.5H19.5V15H21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M9.43934 8L10.4393 7H13.5607L14.5607 8H17V16H7V8H9.43934ZM10.5 11.85C10.5 11.0216 11.1716 10.35 12 10.35C12.8284 10.35 13.5 11.0216 13.5 11.85C13.5 12.6784 12.8284 13.35 12 13.35C11.1716 13.35 10.5 12.6784 10.5 11.85Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCapture;
